import "styled-components";
import { DefaultTheme } from "styled-components";

//Extend the styled components theme.
declare module "styled-components" {
  export interface DefaultTheme {
    headerColor: string;
    buttonColor: string;
    buttonColorHover: string;
    buttonLightBorder: string;
    regularTextColor: string;
    regularTextTypeface: string;
    sixteenBold: string;
    eighteenBold: string;
    buttonColorLight: string;
    greyBorder: string;
    greyBackground: string;
    greyBorderDark: string;
    blueBackground: string;
    lightBlueBackground: string;
    darkBlueBackground: string;
    orangeBackground: string;
    textColor: string;
    textHover: string;
  }
}

export const defaultTheme: DefaultTheme = {
  headerColor: window.CONFIG?.headerColor || "#6b1345",
  buttonColor: "#FF6136",
  buttonColorHover: "#FFB09B",
  buttonColorLight: "#FFB09B",
  buttonLightBorder: "#eaeaea",
  textColor: "#2E3862",
  textHover: "rgba(46,56,98,.1)",
  greyBorder: "#ced4da",
  greyBorderDark:"#808080",
  greyBackground: "#F1F5FF",
  regularTextColor: "#656565",
  blueBackground: "#A1A9DA",
  lightBlueBackground: "#DCDDEC",
  darkBlueBackground: "#2E3762",
  orangeBackground: "#FF6136",
  regularTextTypeface: '"Poppins", sans-serif;',
  sixteenBold: 'bold 16px "Poppins", sans-serif;',
  eighteenBold: 'bold 18px "Poppins", sans-serif;',
};
